// src/api/axiosInstance.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// ============================
// REQUEST INTERCEPTOR
// ============================
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ============================
// RESPONSE INTERCEPTOR
// ============================
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const backend = error.response?.data;

    // -------------------------
    // SUSPENDED USER: DO NOT REDIRECT
    // -------------------------
    if (backend?.status === "SUSPENDED" || backend?.isSuspended) {
      // Let the LoginPage handle showing modal
      return Promise.reject(error);
    }

    // -------------------------
    // AUTO REFRESH TOKEN ON 401
    // -------------------------
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const oldToken = localStorage.getItem("token");

      if (!oldToken) {
        window.location.href = "/register"; // normal redirect
        return Promise.reject(error);
      }

      try {
        const res = await axiosInstance.post("/auth/refresh", null, {
          headers: { Authorization: `Bearer ${oldToken}` },
        });

        const newToken = res.data.token;
        localStorage.setItem("token", newToken);

        // Retry the original request with new token
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/register";
        return Promise.reject(refreshError);
      }
    }

    // -------------------------
    // AUTO LOGOUT ON 403 (not suspended)
    // -------------------------
    if (status === 403 && backend?.status !== "SUSPENDED") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/register";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
